<template>
  <div>
      <help-module :data="data"></help-module>
  </div>
</template>


<script>
import HelpModule from './help_module'
export default {
    data(){
        return{
            data:{
                imgDrako: 'storage/app/media/drako-talk.gif',
                talkDrako:[
                    {
                        talk:'Тук-тук! Привет, друг! Я - дракоша Жора. Я так быстро читаю, что проглатываю книги целиком. Тсс! Секрет моего быстрого чтения - эта платформа. Следуй за подсказками, чтобы разгадать его…'
                    },
                    {
                        talk:'Приключения начинаются здесь! Заходи и выбирай любой тренажер, чтобы стать сообразительнее, быстрее и внимательнее'
                    },
                    {
                        talk:'Дата, время и имя тренера - именно в этом разделе ты узнаешь всё о занятиях'
                    },
                    {
                        talk:'Как быстро ты выполняешь любимый тренажер? Как часто выбираешь правильные ответы? Статистика - полезный инструмент для отличного результата'
                    },
                    {
                        talk:'Любимый раздел каждого ученика! Здесь прячутся рейтинги, статусы и аватары Зайди, чтобы узнать о них больше'
                    },
                    {
                        talk:'Чтобы научиться быстро читать, нужно выполнять задания из этого раздела Именно здесь тренер собрал все нужные тренажеры Нужно просто зайти и начать тренировку!'
                    },
                    {
                        talk:'Раздел поможет быстро зайти на онлайн-урок, и начать тренировку под руководством педагога'
                    },
                    {
                        talk:'Мы собрали все важные обучающие видео в этом разделе! Заходите, чтобы улучшить свой результат в разы'
                    },
                    {
                        talk:'Выполняя домашку, ты зарабатываешь дженкоины! На них можно приобрести понравившиеся сувениры из нашего мерча. Начинай копить дженкоины и выбирай подарки'
                    }
                ]
            }
        }
    },
    name:"helpmoduledata",
    components:{HelpModule},
    methods:{}
}
</script>
